import './OpSelect.scss'

import React from 'react'
import Select from 'react-select'

const arrowRenderer = ({ isOpen }) => (
  isOpen ? <i className="fa fa-caret-up OpSelect__dropdown-arrow"/> : <i className="fa fa-caret-down OpSelect__dropdown-arrow"/>
)

const OpSelect = props => {
  const {
    label, required, className, id, dataTip, value, multi, placeholder,
    clearable, backspaceRemoves, onChange, onBlur, options, disabled, errorMsg, searchable,
    tooltipButtonText, onTooltipButtonClick, dataTestId
  } = props

  const fieldsetClassname = className ? `OpSelect ${className}` : 'OpSelect'
  return (
    <fieldset className={fieldsetClassname} id={id} data-testid={dataTestId || label}>
      {label && <label className={errorMsg && 'error'} data-tip={dataTip}><span className={dataTip && "OpSelect__underline"}>{label}</span>{required && ' *'}</label>}
      {tooltipButtonText && <span className='-tooltip-text' onClick={onTooltipButtonClick || (() => {})}>{tooltipButtonText}</span>}
      <div className='OpSelectInput form-group'>
        <Select
          label={label}
          value={value}
          multi={multi}
          clearable={clearable}
          searchable={searchable}
          backspaceRemoves={backspaceRemoves}
          onChange={onChange}
          onBlur={onBlur}
          options={options}
          disabled={disabled}
          placeholder={placeholder}
          arrowRenderer={arrowRenderer}
          className={errorMsg && 'OpSelectInput__select-error'}
        />
        <div className='OpSelectInput__error'>
          {errorMsg ? (<span className='OpSelectInput__error--message'>{errorMsg}</span>) : null}
        </div>
      </div>
    </fieldset>
  )
}

export default OpSelect
